"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollSelectedSpinToTop = void 0;
var _react = require("react");
/**
 * Calculates the scroll amount, and scrolls the page up
 * so clicked spin is on top of the page
 *
 * @param {Number} stickyHeaderHeight Sticky header height in pixels to calculate the offset
 *
 * @returns {Object}
 * scrollSpinToTop - a function that sets the currently open spin,
 * collapsibleRefs - refs pointing to each collapsible spin component
 */
const useScrollSelectedSpinToTop = (stickyHeaderHeight = 0) => {
  const spinCollapsibleRefs = (0, _react.useRef)([]);
  const scrollSpinToTop = selectedSpinIndex => {
    spinCollapsibleRefs?.current?.[selectedSpinIndex]?.scrollIntoView();
    window.scrollBy(0, -stickyHeaderHeight);
  };
  return {
    scrollSpinToTop,
    spinCollapsibleRefs
  };
};
exports.useScrollSelectedSpinToTop = useScrollSelectedSpinToTop;